import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const OrderActions = styled.div`
  display: flex;
  margin: auto;
  padding: 6px 0;

  ${mq.desktop} {
    align-items: flex-start;
  }
`;

export default {
  OrderActions,
};
